<template>
    <div class="pending">
        <div class="pending__body">
            <h3 class="payment__status-header">{{ $t("banktransfer.transaction.status") }}</h3>
            <div class="pending__body-box">
                <div class="pending__body-box__field">
                    <p>
                        {{ $t("bank.payment.pending") }}
                    </p>
                </div>

                <div class="centre">
                    <button @click="handleCloseIframe" class="close-btn">
                        {{ $t("ui.close.btn") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { injectStore } from "redux-vuex";

export default {
    name: "PendingView",

    setup() {
        const store = injectStore();

        function handleCloseIframe(state) {
            store.Control.close(state);
        }

        return  {
            handleCloseIframe,
        };
    },
};
</script>

<style scoped lang="scss">
    .pending {
        padding-top: 20rem;
        width: 100%;
        display: flex;
        justify-content: center;

        @media screen and (max-width: $breakpoint-middle * 1px) {
            z-index: 9999;
            height: 100vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            top: 0;
            bottom: 0;
            padding: 0;
            position: absolute;
            background: $white;
        }

        &__body {    
            max-width: 349px;

            &-box {
                background: #FFFDFB;
                border: 1px solid rgba(139, 121, 121, 0.15);
                box-sizing: border-box;
                border-radius: 0.4rem;
                margin: 2.4rem auto 0 auto;
                padding: 3.2rem;

                &__field {
                    text-align: center;
                    margin-bottom: 2.4rem;
                    padding-left: 2rem;
                    padding-right: 2rem;

                    p {
                        font-style: normal;
                        font-weight: 400;
                        font-size: 18px;
                        line-height: 25px;
                        text-align: center;
                        color: #333333;
                    }
                }

                .centre {
                    display: flex;
                    justify-content: center;
                }

                button {
                    background-color: $primary-color;
                    color: #090E29;
                    border: none;
                    font-size: 1.326rem;
                    font-weight: 700;
                    padding: 0.7rem 4.5rem;
                    border-radius: 4px;
                }
            }
        }
    }
</style>